import React from "react";
import i18n from "~/assets/js/Helpers/i18n";
import { formatDate } from "~/assets/js/pages/Checkout/sections/TimeSlotSelect/formatDateTime";
import OverviewSection from "~/assets/js/pages/Checkout/sections/OrderOverview/OverviewSection";
import PropTypes from "prop-types";

const OrderDeliverySlot = ({
    slotBegin,
    slotEnd,
    earlierAllowed,
    isPickup,
}) => {
    return (
        <OverviewSection
            title={isPickup ? "overview.pickup" : "overview.timeslot"}
        >
            <OrderDeliverySlotToggleBox
                slotBegin={slotBegin}
                slotEnd={slotEnd}
                earlierAllowed={earlierAllowed}
            />
        </OverviewSection>
    );
};

const OrderDeliverySlotToggleBox = ({ slotBegin, slotEnd, earlierAllowed }) => {
    const deliveryDay = slotBegin.split("T")[0];
    const timeSlotBegin = slotBegin.split("T")[1].substring(0, 5);
    const timeSlotEnd = slotEnd.split("T")[1].substring(0, 5);
    const timeSlot = `${timeSlotBegin} - ${timeSlotEnd} Uhr`;
    const formattedDate = formatDate(deliveryDay);

    return (
        <div className="togglebox">
            <div className="delivery-overview">
                <div className="delivery-overview__day">
                    <strong>{formattedDate.append}</strong>, den&nbsp;
                    {formattedDate.date}
                </div>
                <div className="delivery-overview__time">
                    <strong>{timeSlot}</strong>
                </div>
                <div className="delivery-overview__early-loc">
                    {earlierAllowed && (
                        <span>
                            <i className="fas fa-check"></i>
                            {i18n.t("timeSlotSelect.earyDeliveryConfirmed")}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

OrderDeliverySlot.propTypes = {
    slotBegin: PropTypes.string.isRequired,
    slotEnd: PropTypes.string.isRequired,
    earlierAllowed: PropTypes.bool.isRequired,
    isPickup: PropTypes.bool.isRequired,
};

OrderDeliverySlotToggleBox.propTypes = {
    slotBegin: PropTypes.string.isRequired,
    slotEnd: PropTypes.string.isRequired,
    earlierAllowed: PropTypes.bool.isRequired,
};

export default OrderDeliverySlot;
